import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-parents-feedback-list',
  templateUrl: './parents-feedback-list.component.html',
  styleUrls: ['./parents-feedback-list.component.scss']
})
export class ParentsFeedbackListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists =[];

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/parentsfeedback/').subscribe(
      data => {
        this.lists = data.data;
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

}
